import { css } from '@emotion/react';
import colors from '../../../Themes/colors';

const { black, lightbrown, lighterbrown, lightred, orange, white, red } = colors;

export const listingContainer = css({
    padding: '40px 120px',
});

export const productListingTitle = css({
    font: '70px FRL-Bold, serif',
    color: black,
    textAlign: 'center',
});

export const productListingOptionsContainer = css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
});

export const productListingOptionsText = css({
    font: '18px Archivo-Regular, sans-serif',
    display: 'inline-block',
});

export const productListingOptionsIcon = css({
    width: '27px',
});

export const productsContainer = css({
    padding: '100px 100px 60px',
});

export const productContainer = css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    // margin: '30px 0px',
});

export const productPrice = css({
    fontSize: '1.6rem',
    color: '#616161',
    marginTop: 10,
});

export const productName = css({
    width: '100%',
    height: '6rem',
    fontSize: '1.8rem',
    fontFamily: 'Playfair',
    fontWeight: 700,
    color: black,
    marginTop: '1.2em',
    WebkitLineClamp: 2,
    overflow: 'hidden',
});

export const productImg = css({
    width: '100%',
    height: 150,
    objectFit: 'contain',
    border: '1px solid #E6DFD8',

    '@media(min-width:720px)': {
        height: 300,
        padding: 10,
    },
});

export const productRating = css({
    display: 'block !important',
    marginTop: '0.6em',
});

export const RemoveWishListButton = css({
    font: '1.6rem AcuminRPro',
    color: '#064E72',
    backgroundColor: white,
    border: '2px solid #064E72',
    borderRadius: 12,
    height: 60,
    width: '100%',
    marginTop: '1.2rem',
    transition: 'ease 0.2s',
    '&:hover,&:focus': {
        border: `2px solid ${red}`,
        backgroundColor: red,
        fill: white,
    },
});

export const AddToCartButton = css({

    '@media(min-width:300px)': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        font: '1.6rem AcuminRPro',
        color: 'white',
        backgroundColor: '#064E72',
        border: '2px solid #064E72',
        borderRadius: 12,
        height: 60,
        width: '100%',
        marginTop: '1.2rem',
        transition: 'ease 0.2s',
        '&:hover,&:focus': {
            border: '2px solid #064E72',
            backgroundColor: white,
            color: '#064E72',
            fill: white,
            '& .cart': {
                display: 'none',
            },
            '& .cartBlue': {
                display: 'block',
                width: '25px',
                height: '25px',
                marginLeft: '15px',

                '@media(min-width:992px)': {
                    width: '25px',
                    height: '25px',
                    marginTop: -5,
                },
            },
        },

        '& .cart': {
            display: 'block',
            width: '25px',
            height: '25px',
            marginLeft: '15px',

            '@media(min-width:992px)': {
                width: '25px',
                height: '25px',
                marginTop: -5,
            },
        },
        '& .cartBlue': {
            display: 'none',
        },
    },

    '@media(min-width:1200px)': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        font: '1.6rem AcuminRPro',
        color: 'white',
        backgroundColor: '#064E72',
        border: '2px solid #064E72',
        borderRadius: 12,
        height: 60,
        width: '100%',
        marginTop: '1.2rem',
        transition: 'ease 0.2s',
        '&:hover,&:focus': {
            border: '2px solid #064E72',
            backgroundColor: white,
            color: '#064E72',
            fill: white,
            '& .cart': {
                display: 'none',
            },
            '& .cartBlue': {
                display: 'block',
                width: '25px',
                height: '25px',
                marginLeft: '15px',

                '@media(min-width:992px)': {
                    width: '25px',
                    height: '25px',
                    marginTop: -5,
                },
            },
        },

        '& .cart': {
            display: 'block',
            width: '25px',
            height: '25px',
            marginLeft: '15px',

            '@media(min-width:992px)': {
                width: '25px',
                height: '25px',
                marginTop: -5,
            },
        },
        '& .cartBlue': {
            display: 'none',
        },
    },
});

export const buttonIcons = css({
    width: '25px',
    height: '25px',
    marginLeft: '15px',

    '@media(min-width:992px)': {
        width: '25px',
        height: '25px',
        marginTop: -5,
    },
});

export const customPaginationText = css({
    font: '16px Archivo-Regular, sans-serif',
    color: black,
    '&:hover': {
        color: '#BF7247',
        backgroundColor: 'unset',
    },
});

export const ButtonContainer = css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingTop: 10,
});
